import { useState } from "react";
import { ListTablePaginated } from "../../../general_components/ListTablePaginated";
import { deleteTipoCajas, getTipoCajas, getTipoCajasPaginated, postTipoCajas } from "../helpers/TipoCajasData";
import { TipoCajasForm } from "./TipoCajasForm";
import { Grid, Fab, useTheme, useMediaQuery } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { GenericCard } from "src/general_components/GenericCard";
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import Inventory2Icon from "@mui/icons-material/Inventory2";

export const TipoCajasList = () => {
  const [createButton, setCreateButton] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [buttonMetadatos, setButtonMetadatos] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [tipoCajas, setTipoCajas] = useState([]);
  const listName = "Tipos de Cajas";
  const columns = [
    { field: "id", headerName: "ID", flex: 0.2 }, // la propiedad flex permite setear responsivamente el tamaño de la columna
    { field: "detalle", headerName: "Detalle", flex: 1 }, // la misma se divide entre el total y el porcentaje que le asiganas con un numero

  ];

  const handleDelete = async (id) => {
    const success = await deleteTipoCajas(id);
    if (success) {
      window.location.reload();
    }
  };

  const mobileComponent = ({ row }) => (
    <GenericCard
      row={row}
      columns={columns}
      onEdit={(item) => {
        setTipoCajas(item);
        setCreateButton(true);
      }}
      onDelete={handleDelete}
    />
  );

  const [options, setOptions] = useState({
    cols: columns,
    get: getTipoCajas,
    getPaginated: getTipoCajasPaginated,
    pageSize: [5, 10, 25],
    edit: true,
    delete: deleteTipoCajas,
    limit: 50,
    filter: true,
    exportData: true,
    server: true,

    //DATOS PARA EL FORMULARIO
    createButton: createButton,
    setCreateButton: setCreateButton,
    setDataEdit: setTipoCajas,

    mobileComponent: mobileComponent,
  });

  //CONTROLA CUANDO SE SALE DE UN EDITAR PARA LIMPIAR LA VARIABLE, GUARDA CON EL ID, PUEDE SER QUE EN ALGUNOS NO FUNCIONE
  //TODOS LOS EDITAR DEBERIAN DE TENER UN ID, PERO POR LAS DUDAS COMPROBAR.
  //EL BUTTONMETADATOS SOLO ES PARA ESTE CASO, VERIFICAR CADA OCASION.
  if (
    createButton === false &&
    tipoCajas.id !== undefined &&
    buttonMetadatos === false
  ) {
    setTipoCajas([]);
  }

  const mobileFabs = isMobile && (
    <div style={{ position: 'fixed', bottom: 56, right: 20, display: 'flex', flexDirection: 'column', gap: '10px', zIndex: 9999 }}>
      <Fab
        color="primary"
        aria-label="add"
        onClick={() => {
          setCreateButton(true);
          setTipoCajas([]);
        }}
      >
        <AddIcon />
      </Fab>
    </div>
  );

  return (


    <Grid style={{ marginBottom: "50px", backgroundc: "rgb(241, 243, 244)", paddingTop: 10 }}>
      <PageHeaderCard title={listName} icon={<Inventory2Icon />} />
      <CajasProvider>
        <>

          <ListTablePaginated options={options} />
          <TipoCajasForm
            data={tipoCajas}
            createButton={createButton}
            listName={listName}
            setCreateButton={setCreateButton}
            componentList={"/tipo_cajas/admin"}
            postData={postTipoCajas}
            setOptions={setOptions}
            options={options}
          />
          {mobileFabs}
        </>
      </CajasProvider>
    </Grid>
  );
};

